import { defineCustomElement } from "vue";
import { createPinia } from "pinia";
import ElementPlus from "element-plus";
import ptbr from "element-plus/dist/locale/pt-br.mjs";
import F360Prisma from "@f360-dev/f360-prisma";
import { Register } from "@/ui/vue-components/components";
import ContratoPendenteCe from "./ContratoPendente.ce.vue";
import { createContratoPendenteRouter } from "./router";

const register: Register = {
  register() {
    if (!customElements.get("f360-contrato-pendente")) {
      customElements.define(
        "f360-contrato-pendente",
        defineCustomElement(ContratoPendenteCe, {
          shadowRoot: false,
          configureApp(app) {
            app.use(createPinia());
            app.use(ElementPlus, { locale: ptbr });
            app.use(F360Prisma);
            app.use(createContratoPendenteRouter());
          }
        })
      );
    }
  }
};

export default register;
